export enum ProjectScriptTypeOptionsEnum {
  File = 'file',
  Custom = 'custom'
}
